import { mapActions, mapGetters } from "vuex";

import { VueSlideToggle } from "vue-slide-toggle";
import moment from "moment";

export default {
    name: "archive-order",
    props: ["item"],
    data() {
        return {
            openitemInfo: false,
        };
    },
    components: {
        VueSlideToggle,
    },
    computed: {
        ...mapGetters({}),
    },
    created() {},
    methods: {
        ...mapActions({}),
        formatDate(date) {
            return moment(date).format("YYYY-MM-DD");
        },
    },
};
